module.exports = __webpack_public_path__ + "494cd07c/img/comment-question-icon.7dd26e04.svg";